import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SubNav from '../components/subNav';
import SEO from '../components/SEO';
import TaskModal from '../pages/taskModel';
import { baseUrl } from '../config';



// Dummy data for schedules
const schedulesData = [
  { id: 1, date: '2024-10-01', day: 'Monday', workHours: '9:00 AM - 5:00 PM', mealHours: '1:00 PM - 2:00 PM', taskDescription: 'Script Writing', file: null },
  { id: 2, date: '2024-10-02', day: 'Tuesday', workHours: '10:00 AM - 6:00 PM', mealHours: '12:30 PM - 1:30 PM', taskDescription: 'Script Revisions', file: null },
];

const TeamSchedule = () => {
  const [schedules, setSchedules] = useState(schedulesData);
  const [isModalOpen, setModalOpen] = useState(false);
  const [editingTask, setEditingTask] = useState(null);

  // Handle opening the modal for adding a new task
  const handleAddSchedule = () => {
    setEditingTask(null); // No initial data for adding a new task
    setModalOpen(true);
  };

  // Handle opening the modal for editing a task
  const handleEditSchedule = (schedule) => {
    setEditingTask(schedule); // Pass task data to modal for editing
    setModalOpen(true);
  };

  // Handle saving a new or edited task
  const handleSaveTask = (newTask) => {
    if (editingTask) {
      // Update existing task
      setSchedules((prevSchedules) =>
        prevSchedules.map((task) =>
          task.id === editingTask.id ? { ...task, ...newTask } : task
        )
      );
    } else {
      // Add new task
      setSchedules((prevSchedules) => [
        ...prevSchedules,
        { id: prevSchedules.length + 1, ...newTask },
      ]);
    }
    setModalOpen(false); // Close the modal after saving
  };

  // Handle deleting a schedule
  const handleDeleteSchedule = (scheduleId) => {
    setSchedules((prevSchedules) =>
      prevSchedules.filter((schedule) => schedule.id !== scheduleId)
    );
  };

  return (
    <>
    <SEO
      title="Team Schedule"
      description="View and manage your film production team's shooting schedule and daily assignments on ProducerBuddy."
      url="https://producerbuddy.pilomation.com/team-schedule"
      robots="noindex, nofollow"
    />
    <SubNav/>
    <div className='flex gap-3'>
    {/* Sidebar */}
    <div className="w-64 bg-gray-800 text-white p-5 space-y-6">
    <h1 className="text-2xl font-bold"><Link to='/production-house'>Production Dashboard</Link></h1>
    <nav>
      <ul className="space-y-4 mt-4">
        <li className="hover:text-yellow-400"><Link to='/jobpostings'>Job Postings</Link></li>
        <li className="hover:text-yellow-400">Pre-Production Tools</li>
        <li className="hover:text-yellow-400">Production Status</li>
        <li className="hover:text-yellow-400">Post-Production Tools</li>
        <li className="hover:text-yellow-400"><Link to='/collaborations'>Collaborations</Link></li>
        <li className="hover:text-yellow-400"><Link to='/team'>Team</Link></li>
      </ul>
    </nav>
  </div>
    <div className="p-2 mt-4 ">
      <h1 className="text-3xl font-bold mb-8 text-center" style={{fontSize:'24px'}}>Team Member's Schedule</h1>
      <div className="flex justify-end mb-4">
        <button
          className="bg-blue-600 text-white px-4 py-2 rounded-lg"
          onClick={handleAddSchedule}
        >
          Add Schedule
        </button>
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white shadow-md rounded-lg">
          <thead>
            <tr>
              <th className="px-6 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-sm font-semibold text-gray-700 uppercase">Date</th>
              <th className="px-6 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-sm font-semibold text-gray-700 uppercase">Day</th>
              <th className="px-6 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-sm font-semibold text-gray-700 uppercase">Work Hours</th>
              <th className="px-6 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-sm font-semibold text-gray-700 uppercase">Meal Hours</th>
              <th className="px-6 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-sm font-semibold text-gray-700 uppercase">Task Description</th>
              <th className="px-6 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-sm font-semibold text-gray-700 uppercase">File</th>
              <th className="px-6 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-sm font-semibold text-gray-700 uppercase">Actions</th>
            </tr>
          </thead>
          <tbody>
            {schedules.map((schedule) => (
              <tr key={schedule.id}>
                <td className="px-6 py-4 border-b border-gray-200">{schedule.date}</td>
                <td className="px-6 py-4 border-b border-gray-200">{schedule.day}</td>
                <td className="px-6 py-4 border-b border-gray-200">{schedule.workHours}</td>
                <td className="px-6 py-4 border-b border-gray-200">{schedule.mealHours}</td>
                <td className="px-6 py-4 border-b border-gray-200">{schedule.taskDescription}</td>
                <td className="px-6 py-4 border-b border-gray-200">
                  {schedule.file ? (
                    <a href={schedule.file} className="text-blue-600" target="_blank" rel="noopener noreferrer">View File</a>
                  ) : (
                    <span className="text-gray-500 italic">No file uploaded</span>
                  )}
                </td>
                <td className=" flex px-6 py-4 border-b border-gray-200">
                  <button
                    className="bg-green-500 text-white px-2 py-2 rounded-lg mr-2"
                    onClick={() => handleEditSchedule(schedule)}
                  >
                    Edit
                  </button>
                  <button
                    className="bg-red-600 text-white px-2 py-2 rounded-lg"
                    onClick={() => handleDeleteSchedule(schedule.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <TaskModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        onSave={handleSaveTask}
        initialData={editingTask} // Pass initial data to the modal
      />
    </div>
   </div>
    </>
    
  );
};

export default TeamSchedule;

